import { APIS } from '../constants/apis';
import { fetchAPI } from '../utils/fetchAPI';

export const saveActivity = async ({ jwt, data }) => {
  try {
    await fetchAPI({
      url: APIS.saveActivity,
      method: 'POST',
      header: {
        Authorization: `Bearer ${jwt}`,
      },
      data,
    });
  } catch (err) {
    throw new Error(err.message);
  }
};
